<template>
  <div class="loading-container">
    <div v-if="isFetching" class="loading-overlay">
      <div class="loader"></div>
    </div>

  <span v-else v-show="isShowPage">
    <v-row>
      <v-col class="text-right">
        <!-- <span v-if="items.length > 0">{{ items.length + 1 + ' data ditemukan' }}</span> -->
        <v-btn class="-ma-5" depressed outlined :color="colorActive" @click="openDialogFilter()">
          <v-icon left :color="colorActive"> $ic-filter </v-icon>
          Filter
        </v-btn>
      </v-col>
    </v-row>

<!--    <v-row v-if="!isFetching" style="height: 90vh">-->
<!--      <l-map ref="map" :zoom="zoom" :center="center"  :options="mapOptions"-->
<!--             style="height: 600px;  z-index: 221">-->
<!--        <v-icondefault></v-icondefault>-->
<!--        <l-tile-layer :url="url" :attribution="attribution" />-->
<!--        <v-marker-cluster :options="clusterOptions">-->
<!--            <v-marker v-for="(c, idx) in locationMarkerList" :key="idx"  :lat-lng="c.position"  >-->
<!--              <l-icon :icon-url="iconSelector(c)" />-->
<!--            </v-marker>-->
<!--        </v-marker-cluster>-->
<!--      </l-map>-->
<!--    </v-row>-->

    <v-row v-if="!isFetching && statusValue === '' " style="height: 90vh" >
       <l-map ref="map" :zoom="zoom" :center="center" :options="mapOptions"
              style="height: 600px; margin-top: 20px; z-index: 221">
        <l-tile-layer :url="url" :attribution="attribution" />

           <l-control-fullscreen position="topright"  :options="fullscreenOptions" />

        <l-marker v-for="(marker, idx) in locationMarkerList" :key="idx" :options="{ opacity: 1.0, riseOnHover: true }"
                  ref="markers" :lat-lng="marker.position">
          <l-popup :options="{ closeButton: false }">
            <div class="w-100">
              <div class=" w-100 d-flex justify-end">
                 <v-icon v-if="marker.status !== 'PLN' && marker.status !== 'NON PLN' " :color="colorActive"
                         @click="openDialogEdit(marker?.id)"
                 >mdi-square-edit-outline</v-icon>

              </div>

            <table class="popup-table">
                <tr>
                  <td class="popup-property ">Nama :</td>
                  <td class="popup-value word-wrap">{{ marker.nama }}</td>
                </tr>
                <tr>
                  <td class="popup-property ">Kategori :</td>
                  <td class="popup-value word-wrap">{{ marker.kategori }}</td>
                </tr>
              <tr>
                  <td class="popup-property">Daya :</td>
                  <td class="popup-value word-wrap">{{ marker.daya }}</td>
                </tr>
              <tr>
                  <td class="popup-property">Jenis :</td>
                  <td class="popup-value word-wrap">{{ marker.jenisSpklu }}</td>
                </tr>
              <tr>
                  <td class="popup-property">Unit :</td>
                  <td class="popup-value word-wrap">{{ marker.namaUnit }}</td>
                </tr>
              </table>
            </div>
          </l-popup>
          <l-icon :icon-url="iconSelector(marker)" :icon-size="['15']" />
        </l-marker>

    <!-- Legend Maps -->
         <l-control position="bottomleft" >
           <div class="container-legend">

          <div class="icon-legend">
              <div>
                <img src="/maps/ic-spklu-red.svg" />
              </div>

            <span>:</span>

            <div>
             PLN - UFC
            </div>
          </div>

           <div class="icon-legend">
              <div>
                <img src="/maps/ic-spklu-yellow.svg" />
              </div>

            <span>:</span>

            <div>
             PLN - FC
            </div>
          </div>

           <div class="icon-legend">
              <div>
                <img src="/maps/ic-spklu-green.svg" />
              </div>

            <span>:</span>

            <div>
            PLN - MC
            </div>
          </div>

           <div class="icon-legend">
              <div>
                <img src="/maps/ic-spklu-blue.svg" />
              </div>

            <span>:</span>

            <div>
              NON PLN
            </div>
          </div>

           <div class="icon-legend">
              <div>
                <img src="../../assets/maps/ic-spklu-white.svg" />
              </div>

            <span>:</span>

            <div>
              RENCANA
            </div>
          </div>
           </div>
        </l-control>
      </l-map>
    </v-row>

    <v-row v-else style="height: 90vh" >
       <l-map  ref="map" :zoom="zoom" :center="center" :options="mapOptions"
              style="height: 600px; margin-top: 20px; z-index: 221">
        <l-tile-layer :url="url" :attribution="attribution" />

        <l-marker v-for="(marker, idx) in filteredItems" :key="idx" :options="{ opacity: 1.0, riseOnHover: true }"
                  ref="markers" :lat-lng="marker.position">
          <l-popup :options="{ closeButton: false }">
             <div class="w-100">
              <div class=" w-100 d-flex justify-end">
                 <v-icon v-if="marker.status !== 'PLN' && marker.status !== 'NON PLN' "  :color="colorActive"
                         @click="openDialogEdit(marker?.id)"
                 >mdi-square-edit-outline</v-icon>

              </div>

            <table class="popup-table">
                <tr>
                  <td class="popup-property ">Nama :</td>
                  <td class="popup-value word-wrap">{{ marker.nama }}</td>
                </tr>
              <tr>
                  <td class="popup-property ">Kategori :</td>
                  <td class="popup-value word-wrap">{{ marker.kategori }}</td>
                </tr>
              <tr>
                  <td class="popup-property">Daya :</td>
                  <td class="popup-value word-wrap">{{ marker.daya }}</td>
                </tr>
              <tr>
                  <td class="popup-property">Jenis :</td>
                  <td class="popup-value word-wrap">{{ marker.jenisSpklu }}</td>
                </tr>
              <tr>
                  <td class="popup-property">Unit :</td>
                  <td class="popup-value word-wrap">{{ marker.namaUnit }}</td>
                </tr>
              </table>
            </div>
            </l-popup>
          <l-icon :icon-url="iconSelector(marker)" :icon-size="['15']" />
        </l-marker>

         <!-- Legend Maps -->
         <l-control position="bottomleft" >
           <div class="container-legend">

          <div class="icon-legend">
              <div>
                <img src="/maps/ic-spklu-red.svg" />
              </div>

            <span>:</span>

            <div>
             PLN - UFC
            </div>
          </div>

           <div class="icon-legend">
              <div>
                <img src="/maps/ic-spklu-yellow.svg" />
              </div>

            <span>:</span>

            <div>
             PLN - FC
            </div>
          </div>

           <div class="icon-legend">
              <div>
                <img src="/maps/ic-spklu-green.svg" />
              </div>

            <span>:</span>

            <div>
            PLN - MC
            </div>
          </div>

           <div class="icon-legend">
              <div>
                <img src="/maps/ic-spklu-blue.svg" />
              </div>

            <span>:</span>

            <div>
              NON PLN
            </div>
          </div>

           <div class="icon-legend">
              <div>
                <img src="../../assets/maps/ic-spklu-white.svg" />
              </div>

            <span>:</span>

            <div>
              RENCANA
            </div>
          </div>
           </div>
        </l-control>
      </l-map>
    </v-row>

    <hr v-if="showMap" class="line-separator" />
    <span class="page-sub-title">{{ table_title }}</span>
<!-- Table View -->
     <v-row>
      <v-col class="pt-5">
        <!-- <Table :headers="headers" :loading="isFetching" :items="items" @onChangePage="getDataTable" @sortOptions="updateSortDatatable" :defaultSize="20">
        </Table> -->
        <v-data-table v-if="statusValue === '' " :headers="headers" :items="items" :items-per-page="itemsPerPage" class="datatable" :search="search"
                      hide-default-footer :page.sync="page" @page-count="pageCount = $event">
          <template v-slot:item.jml_transaksi="{ item }">
            {{ formatCurrency(item.jml_transaksi).split(",")[0] }}
          </template>
        </v-data-table>
        <v-data-table v-else :headers="headers" :items="filteredItems" :items-per-page="itemsPerPage" class="datatable" :search="search"
                      hide-default-footer :page.sync="page" @page-count="pageCount = $event">
          <template v-slot:item.jml_transaksi="{ item }">
            {{ formatCurrency(item.jml_transaksi).split(",")[0] }}
          </template>
        </v-data-table>
        <v-row>
          <v-col class="mt-5" cols="6">
            Menampilkan
            <v-select v-model="itemsPerPage" :items="[5, 10, 20, 30, 50]" dense solo flat class="ml-1 mr-1 size-select"
                      @change="
                itemsPerPage = parseInt($event, 10);
              page = 1;
              "></v-select>
            data dari <b>{{ items.length }}</b>
          </v-col>
          <v-spacer></v-spacer>
          <v-col class="text-right mt-5" cols="6">
            <v-pagination v-model="page" :length="pageCount" :total-visible="5"></v-pagination>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-dialog v-model="dialog" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <v-row>
            <v-col>
              <span>{{ dialogTitle }}</span>
            </v-col>
            <v-col cols="1" class="text-right">
              <v-btn icon x-small @click="dialog = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-row>
              <v-col class="pb-0 pt-1">
                <v-list>
                  <template v-for="(item) in chargeBoxList">
                    <v-list-item>
                      <v-icon v-if="item.isActive" class="mr-5">$ic-spklu-blue</v-icon>
                      <v-icon v-else class="mr-5">$ic-spklu-red</v-icon>
                      <v-list-item-content>
                        <v-list-item-title v-html="item.namaChargebox"></v-list-item-title>
                        <v-list-item-subtitle v-html="item.dayaChargebox"></v-list-item-subtitle>
                      </v-list-item-content>
                      <v-list-item-action>
                        <v-tooltip right>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn icon v-bind="attrs" v-on="on">
                              <v-icon color="grey lighten-1">mdi-information</v-icon>
                            </v-btn>
                          </template>
                          <span v-for="(connector, j) in item.connectors" :key="j">
                            <table>
                              <tr>
                                <td>{{ "(" + parseInt(j + 1) + ")" }}</td>
                                <td>Nama Connector</td>
                                <td>: {{ connector.namaKonektor }}</td>
                              </tr>
                              <tr>
                                <td></td>
                                <td>Status Connector</td>
                                <td>
                                  :
                                  <span>{{
                                      enumToStatus(connector.status)
                                    }}</span>
                                </td>
                              </tr>
                            </table>
                          </span>
                        </v-tooltip>
                      </v-list-item-action>
                    </v-list-item>
                  </template>
                </v-list>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn small depressed :color="colorActive" dark @click="dialog = false">
            Kembali
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogFilter" persistent max-width="600px"  style="z-index: 999" >
      <v-card>
        <v-card-title>
          <v-row>
            <v-col>
              <span>Filter Data</span>
            </v-col>
            <v-col class="text-right">
              <v-btn icon x-small @click="dialogFilter = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-title>
        <v-card-text>
          <v-container>
<!--            <v-row>-->
              <!-- <v-col class="pb-0 pt-1">
                <div class="label-custom mb-2" :style="'color:' + colorActive">
                  Status
                </div>
                <v-autocomplete
                  v-model="input.is_active"
                  :items="optionsAvailability"
                  label="Semua Status"
                  dense
                  solo
                  flat
                  outlined
                  item-text="name"
                  item-value="id"
                  return-object
                  cache-items
                  clearable
                  :color="colorActive"
                >
                </v-autocomplete>
              </v-col> -->
<!--            </v-row>-->
             <v-row>
              <v-col class="pb-0 pt-1">
                <div class="label-custom mb-2" :style="'color:' + colorActive">
                  Status SPKLU
                </div>
                 <v-autocomplete
                     v-model="statusValue"
                     :items="statusSPKLU"
                     label="Status"
                     dense solo flat outlined
                 ></v-autocomplete>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="pb-5 pt-1">
                <div class="label-custom mb-2" :style="'color:' + colorActive">
                  Unit
                </div>
                <v-text-field v-model="input.searchBranch" label="Cari Lokasi" dense solo flat outlined clearable>
                </v-text-field>
                <span>Selected:
                  {{
                    input.branch.name ? input.branch.name : "unit belum dipilih"
                  }}
                  <v-icon v-show="input.branch.id" @click="
                    input.branch = {};
                  active = [];
                  ">mdi-close</v-icon>
                </span>
                <div v-show="!input.branch.id" style="overflow-y: scroll; height: 300px">
                  <v-treeview activatable :active="active" :items="tempOptionsBranch"
                              @update:active="treeClick"></v-treeview>
                </div>
              </v-col>
            </v-row>

          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn small depressed color="#999999" text @click="dialogFilter = false">
            Kembali
          </v-btn>
          <v-btn small depressed :color="colorActive" @click="
            dialogFilter = false;
          reGetData();
          " dark>
            Cari
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

     <v-dialog
         v-model="editLokasi"
         persistent
         max-width="600px"
         style="z-index: 999"
     >
        <v-card>
          <v-card-title>
            <v-row>
              <v-col>
                <span>Edit Lokasi</span>
              </v-col>
              <v-col class="text-right">
                <v-btn
                    icon
                    x-small
                    @click="editLokasi = false"
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col class="pb-1 pt-1">
                  <div class="label-custom mb-2" :style="'color:' + colorActive">Nama SPKLU</div>
                  <v-text-field
                      v-model="formEdit.namaSpklu"
                      label="Ubah Nama SPKLU"
                      dense
                      solo
                      flat
                      outlined
                      readonly
                      disabled
                  >
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <div class="label-custom mb-2" :style="'color:' + colorActive">Input Latitude</div>
                  <v-text-field
                      v-model="formEdit.latitude"
                      label="Input Latitude"
                      placeholder="123.4567"
                      dense
                      solo
                      flat
                      outlined
                      clearable
                  >
                  </v-text-field>
                  </v-col>

                  <v-col>
                   <div class="label-custom mb-2" :style="'color:' + colorActive">Input Longitude</div>
                  <v-text-field
                      v-model="formEdit.longitude"
                      label="Input Longitude"
                      placeholder="123.4567"
                      dense
                      solo
                      flat
                      outlined
                      clearable
                  >
                  </v-text-field>
                  </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                small
                depressed
                color="#999999"
                text
                @click="editLokasi = false"
            >
              Kembali
            </v-btn>
            <v-btn
                small
                depressed
                :color="colorActive"
                @click="UpdateCordinates"
                dark
            >
              Perbaharui
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
  </span>
  </div>
</template>
<script>
import 'leaflet/dist/leaflet.css'
import * as Vue2Leaflet from 'vue2-leaflet'
import { latLng } from 'leaflet'
import { LMap, LTileLayer, LMarker, LPopup, LIcon, LCircle, LControl } from 'vue2-leaflet'
import SpkluService from '@/services/default/SpkluService'
import RefService from '@/services/default/RefService'
import { StorageService } from '@/services/storage.service'
import Vue2LeafletMarkerCluster from 'vue2-leaflet-markercluster'
import icSPKLU from '@/assets/maps/ic-spklu-white.svg'
import icSPKLUBlue from '@/assets/maps/ic-spklu-blue.svg'
import LControlFullscreen from 'vue2-leaflet-fullscreen'
import alert from '@/commons/helper/alert.helper'

const spkluService = SpkluService.build()
const refService = RefService.build()

export default {
  name: 'spklu-lokasi-spklu',
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
    LIcon,
    LCircle,
    LControl,
    'v-marker': Vue2Leaflet.LMarker,
    'v-popup': Vue2Leaflet.LPopup,
    'v-marker-cluster': Vue2LeafletMarkerCluster,
    'v-icondefault': Vue2Leaflet.LIconDefault,
    LControlFullscreen
  },
  data: () => ({
    dateMenu: false,
    searchDate: [],
    colorActive: '#2671D9',
    colorInactive: '#9A9A9A',

    search: '',
    sortSettings: '',
    isFetching: false, // for datatable
    locationMarkerList: [],

    // map properties
    zoom: 5,
    center: latLng(-2.372369, 115.421875),
    url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
    attribution:
        '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
    showParagraph: false,
    bounds: null,
    mapOptions: {
      // zoomSnap: 0.5
      zoomControl: true,
      touchZoom: false,
      doubleClickZoom: false,
      scrollWheelZoom: true,
      boxZoom: false,
      keyboard: false,
      dragging: true
    },
    fullscreenOptions: {
      title: {
        false: 'Switch to full-screen view',
        true: 'Exit full-screen mode'
      }
    },
    showMap: false,
    isShowPage: false,
    mapObj: {},
    table_title: '',
    timer: '',
    // dialog properties
    dialog: false,
    dialogTitle: '',
    chargeBoxList: [],
    showTooltip: false,
    // client side pagination properties
    page: 1,
    pageCount: 0,
    itemsPerPage: 10,
    // filter
    input: {
      jml_transaksi: {},
      branch: {},
      spklu: {},
      searchBranch: '',
      is_active: {}
    },
    dialogFilter: false,
    optionsSpklu: [],
    optionsLokasi: [],
    optionsBranch: [],
    tempOptionsBranch: [],
    searchSpkluKeyword: '',
    awaitingSearch: false,
    active: [],
    itemsExcel: [],
    param: {},
    clusterOptions: {},

    //   Table
    headers: [
      // { value: 'number', text: 'No.', sortable: false, align: 'center' },
      { value: 'nama', text: 'Nama SPKLU', align: 'left' },
      { value: 'unitupi', text: 'UNIT/UPI', align: 'left' },
      { value: 'status', text: 'STATUS', align: 'center' },
      { value: 'daya', text: 'DAYA', align: 'center' }
    ],
    items: [],
    statusSPKLU: ['Semua', 'PLN - semua', 'PLN - UFC', 'PLN - FC', 'PLN - MC', 'NON PLN', 'RENCANA'],
    statusValue: '',
    filteredItems: [],
    editLokasi: false,
    formEdit: {
      id: null,
      namaSpklu: '',
      latitude: '',
      longitude: ''
    }
  }),
  async created () {
    // const currentDate = new Date()
    //
    // const year = currentDate.getFullYear()
    // const month = String(currentDate.getMonth() + 1).padStart(2, '0')
    // const day = String(currentDate.getDate()).padStart(2, '0')
    //
    // const endDate = `${year}-${month}-${day}`
    //
    // // Get the date for last month
    // const lastMonthDate = new Date(currentDate)
    // lastMonthDate.setMonth(lastMonthDate.getMonth() - 1)
    //
    // const lastMonthYear = lastMonthDate.getFullYear()
    // const lastMonthMonth = String(lastMonthDate.getMonth() + 1).padStart(
    //   2,
    //   '0'
    // )
    // const lastMonthDay = String(lastMonthDate.getDate()).padStart(2, '0')
    //
    // const startDate = `${lastMonthYear}-${lastMonthMonth}-${lastMonthDay}`

    this.param = Object.assign({
      q: ''
    })

    this.table_title = 'Detail'
    this.isShowPage = true
    this.showMap = true
    await this.getSpkluCoordinate()
    await this.getSpkluCard()
    await this.getBranchList()
  },
  computed: {
    dateDisp () {
      return this.searchDate.join(' ~ ')
      // format/do something with date
    }
  },
  mounted: async function () {
    const responseAuth = await StorageService.getAuthdata()
    await this.getBranchList()
    // await this.reGetData()

    const newVal = this.input.branch.id
    const oldVal = responseAuth.branch.idBranch

    const currentDate = new Date()
    const year = currentDate.getFullYear()
    const month = (currentDate.getMonth() + 1).toString().padStart(2, '0')
    const day = currentDate.getDate().toString().padStart(2, '0')
    // const Periode = `${year}-${month}-${day}`;

    const start = `${year}-${month}-01`
    const end = `${year}-${month}-${day}`

    if (newVal === undefined) {
      this.searchDate.push(start, end)
      this.param.startDate = this.searchDate[0]
      this.param.endDate = this.searchDate[1]

      if (responseAuth.branch.name !== 'PUSAT') {
        this.input.branch.id = responseAuth.branch.idBranch
        this.input.branch.name = responseAuth.branch.name
      }

      await this.getOptionsSpklu(oldVal)
      // await this.reGetData()
    }

    setTimeout(() => {
      this.$nextTick(() => {
        this.clusterOptions = { disableClusteringAtZoom: 11 }
      })
    }, 5000)

    // if (this.$route.path === '/dashboard/spklu-fast-charging') {
    //   this.$nextTick(() => {
    //     this.map = this.$refs.map.mapObject
    //     this.mapObj = this.map
    //   })
    //   // re-get data every 1 minute
    //   this.timer = setInterval(() => {
    //     this.resetData()
    //     // this.getSpkluACHomeCharging()
    //     const tableQuery = JSON.parse(localStorage.getItem('tableQuery'))
    //     if (tableQuery) {
    //       this.getDataTable(tableQuery.page, tableQuery.size)
    //     } else {
    //       this.getDataTable()
    //     }
    //     this.isShowPage = true
    //   }, 60000)
    // }
  },
  destroyed: function () {
    // kill re-get data every 1 minute
    clearInterval(this.timer)
  },
  watch: {
    'input.branch': function (newVal, oldVal) {
      if (newVal.id !== oldVal.id) {
        this.getOptionsSpklu(newVal.id)
      }
    },
    'input.searchBranch': function (val) {
      if (!val) {
        this.tempOptionsBranch = this.optionsBranch
      } else {
        this.tempOptionsBranch = this.containComplexV2(this.optionsBranch, val)
      }
    }
    // searchSpkluKeyword (val) {
    //   const self = this
    //   if (!this.awaitingSearch) {
    //     setTimeout(() => {
    //       if (val !== '' && val !== null) {
    //         self.getOptionsSpklu()
    //       }
    //       self.awaitingSearch = false
    //     }, 1000)
    //   }
    //   this.awaitingSearch = true
    // }
  },
  methods: {

    allowedDates: function (val) {
      var today = new Date()
      var year = today.getFullYear()
      var month = (today.getMonth() + 1).toString().padStart(2, '0')
      var day = today.getDate().toString().padStart(2, '0')
      var currentDate = `${year}-${month}-${day}`

      return val <= currentDate
    },

    async getSpkluCoordinate (param) {
      this.isFetching = true

      // const response = await spkluService.getLocationSpklu(param)
      const response = await spkluService.getProyeksiSpklu(param)

      // console.log('response data =>', response.data.data)

      const {
        data: { data }
      } = response

      // console.log('data', data)

      // let firstLoad = true
      this.locationMarkerList = []

      // data.map((obj, idx) => {
      //   Object.assign(obj, { id: idx })
      // })

      for (let i = 0; i < data.length; i++) {
        // set location marker
        const position = latLng(data[i].latitude, data[i].longitude)

        // find existing index
        // const idx = this.locationMarkerList.findIndex(
        //   (x) => x.id === data[i].id
        // )
        // console.log('idx', idx)
        // if (idx === -1) {
        const newmarker = {
          id: data[i].id,
          nama: data[i].nama_spklu,
          alamat: data[i].lokasiSpklu ? data[i].lokasiSpklu : '-',
          daya: data[i].daya,
          status: data[i].status ? data[i].status : '-',
          kategori: data[i].kategori ? data[i].kategori : '-',
          position: position,
          latitude: data[i].latitude,
          longitude: data[i].longitude,
          skema: data[i].skema ? data[i].skema : '-',
          unitupi: data[i].unitupi,
          jenisSpklu: data[i].jenisSpklu ? data[i].jenisSpklu : '-',
          namaUnit: data[i].unitupi + ' - ' + data[i].namaUnit
        }
        this.locationMarkerList.push(newmarker)
        // }
      }
      //
      // if (firstLoad) {
      //   if (this.zoom === 4) {
      //     this.zoom += 1
      //   } else {
      //     const self = this
      //     this.zoom -= 1
      //     setTimeout(function () {
      //       self.zoom += 1
      //     }, 300)
      //   }
      // }

      // set datatable client side data
      this.items = this.locationMarkerList

      const temp = this.items
      // reform data for excel export
      this.itemsExcel = temp.map((item, index) => {
        return {
          Nomor: index + 1,
          'ID SPKLU': item.id,
          Nama: item.nama,
          Alamat: item.alamat,
          'Kapasitas (kW)': item.daya,
          Status: item.status,
          'Jumlah Transaksi': item.jml_transaksi,
          'Jumlah Charger': item.jml_charger,
          'Jumlah Connector': item.jml_connector,
          'Kategori SPKLU': item.kategori,
          Latitude: item.latitude,
          Longitude: item.longitude
        }
      })

      this.isFetching = false
    },

    async  filterItemsByStatus () {
      if (this.statusValue === '' || this.statusValue === 'Semua') {
        this.filteredItems = this.items
      } else {
        if (!this.statusValue.startsWith('PLN -')) {
          this.filteredItems = this.items.filter(item => item.status === this.statusValue)
        } else {
          const [status, category] = this.statusValue.split(' - ')
          if (category === 'semua') {
            this.filteredItems = this.items.filter(item => item.status === status)
          } else {
            this.filteredItems = this.items.filter(item => item.status === status && item.kategori === category)
          }
          // const parts = this.statusValue.split(' - ')
          // console.log('parts 1', parts)
          //
          // const category = parts.length > 1 ? parts[1].trim() : ''
          // console.log('status ke 2', category)
          //
          // console.log('status', this.statusValue)
          // const parts = this.statusValue.split(' - ')
          // console.log('parts', parts)
          //
          // const category = parts.length > 1 ? parts[1].trim() : ''
          // console.log('status ke 2', category)
          // this.filteredItems = this.items.filter(item => item.kategori === category)
        }
      }
    },

    async openDialog (marker) {
      await this.getSpkluAvailability(marker.id)
      this.dialogTitle = marker.nama
      this.dialog = true
    },
    async getSpkluAvailability (id) {
      const param = {
        idSpklu: id
      }
      const response = await spkluService.getDetailAvailabilitySpklu(param)
      const {
        data: { data }
      } = response
      this.chargeBoxList = data
    },
    iconSelector (data) {
      if (data.status === 'PLN') {
        if (data.kategori === 'UFC') {
          return '/maps/ic-spklu-red.svg'
        } else if (data.kategori === 'FC') {
          return '/maps/ic-spklu-yellow.svg'
        } else {
          return '/maps/ic-spklu-green.svg'
        }
        // return icSPKLUBlue
      } else if (data.status === 'NON PLN') {
        return '/maps/ic-spklu-blue.svg'
      } else if (data.status === 'RENCANA') {
        return icSPKLU
      }
    },

    // iconSelector (data) {
    //   if (data.kategori !== 'PLN') {
    //     return '/maps/ic-spklu-blue.svg'
    //   } else if (data.jml_transaksi > 50) {
    //     return '/maps/ic-spklu-green.svg'
    //   } else if (data.jml_transaksi >= 11 && data.jml_transaksi <= 50) {
    //     return '/maps/ic-spklu-yellow.svg'
    //   } else if (data.jml_transaksi <= 10) {
    //     return '/maps/ic-spklu-red.svg'
    //   }
    // },

    async getSpkluCard (param) {
      const response = await spkluService.getLocationCard(param)
      const {
        data: {
          data: { hijau, kuning, merah, biru }
        }
      } = response
      this.cardItems = {
        hijau: hijau,
        kuning: kuning,
        merah: merah,
        biru: biru
      }
    },
    // async resetData () {
    //   this.cardItems = [
    //     {
    //       value: 0,
    //       status: 1,
    //       title: 'available',
    //       order_number: 0
    //     },
    //     {
    //       value: 0,
    //       status: 2,
    //       title: 'in_use',
    //       order_number: 1
    //     },
    //     {
    //       value: 0,
    //       status: 4,
    //       title: 'unavailable',
    //       order_number: 2
    //     }
    //   ]
    //   this.items = {}
    // },
    async exportExcel () {
      document.getElementById('d').click()
    },
    openDialogFilter () {
      this.dialogFilter = true
    },
    async  openDialogEdit (id) {
      const response = await spkluService.getDataKordinatById({}, id)
      const {
        data: { data }
      } = response

      this.formEdit = {
        id: data.id,
        namaSpklu: data.nama_spklu,
        latitude: data.latitude,
        longitude: data.longitude
      }

      this.editLokasi = true
    },

    async UpdateCordinates () {
      const dataForm = {
        latitude: this.formEdit.latitude,
        longitude: this.formEdit.longitude
      }
      try {
        const res = await spkluService.putDataKordinat(dataForm, this.formEdit.id)
        alert.success(res.data.message)
        await this.getSpkluCoordinate()
        this.editLokasi = false
      } catch (err) {
        const data = err.response.data
        alert.failed(data)
      }
    },
    // async getCompanyList () {
    //   const response = await refService.getCompanyList()
    //   const { data: { data } } = response
    //   const temp = data.map(item => {
    //     return {
    //       id: item.idCompany,
    //       text: item.name
    //     }
    //   })
    //   this.filterOptions.company = temp
    // },
    async getBranchList () {
      const param = {
        companyId: 1,
        branchId: ''
      }
      const response = await refService.getBranchList(param)
      const {
        data: { data }
      } = response

      const temp = data.map((item) => {
        // remap level 1
        item.child = item?.child?.map((item2) => {
          return {
            id: item2.id,
            name: item2.id.split('').join('.') + ' - ' + item2.name,
            // children: item2.child
          }
        })
        return {
          id: item.id,
          name: item.id.split('').join('.') + ' - ' + item.name,
          children: item.child
        }
      })

      this.optionsBranch = temp
      this.tempOptionsBranch = temp

      localStorage.setItem(
        'branch_listV2',
        JSON.stringify({
          data: temp
        })
      )
      // }
    },
    treeClick (value) {
      if (value.length > 0) {
        const branch = JSON.parse(localStorage.getItem('branch_listV2'))?.data
        this.input.branch = this.findComplexPerencanaan(branch, value[0])
      }
    },
    getOptionsSpklu: async function (param) {
      this.paging.page = 0
      this.paging.size = 999

      // // const param = Object.assign({ q: this.searchSpkluKeyword }, this.paging)
      // const param = Object.assign({ q: id }, this.paging)
      // const response = await refService.getSpkluList(param)
      // const { data } = response
      // if (data.success !== true) return
      //
      // if (this.input.branch.id !== param.q || param.q === undefined) {
      //   this.optionsSpklu = []
      // } else {
      //   this.optionsSpklu = data.data.content.map((data) => {
      //     return {
      //       id: data.idSpklu,
      //       name: data.spkluName
      //     }
      //   })
      // }
    },
    async reGetData () {
      this.isFetching = true
      let q = ''

      if (this.input.spklu && this.input.spklu.id) {
        q = this.input.spklu.id
      } else if (this.input.branch && this.input.branch.id) {
        q = this.input.branch.id
      }

      // const isActive = this.input.is_active ? this.input.is_active.id : ''

      this.param = Object.assign({
        // card: this.input.jml_transaksi ? this.input.jml_transaksi.id : '',
        q: q
        // isActive: isActive
      })
      // if (this.searchDate.length > 1) {
      //   param.startDate = this.searchDate[0]
      //   param.endDate = this.searchDate[1]
      // } else if (this.searchDate.length === 1) {
      //   param.startDate = this.searchDate[0]
      //   param.endDate = this.searchDate[0]
      // }

      // const param = {
      //   card: this.input.jml_transaksi ? this.input.jml_transaksi.id : "",
      //   q: q,
      //   isActive: isActive,
      // };

      await this.filterItemsByStatus()
      await this.getSpkluCoordinate(this.param)
      await this.getSpkluCard(this.param)

      this.isFetching = false
    }
  }
}
</script>
<style scoped>
@import "~leaflet/dist/leaflet.css";
@import "~leaflet.markercluster/dist/MarkerCluster.css";
@import "~leaflet.markercluster/dist/MarkerCluster.Default.css";

html, body {
  height: 100%;
  margin: 0;
}

.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0); /* Hitam transparan */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
/* HTML: <div class="loader"></div> */
.loader {
  width: 50px;
  aspect-ratio: 1;
  border-radius: 50%;
  background:
      radial-gradient(farthest-side,#707070 94%,#0000) top/8px 8px no-repeat,
      conic-gradient(#0000 30%,#707070);
  -webkit-mask: radial-gradient(farthest-side,#0000 calc(100% - 8px),#000 0);
  animation: l13 1s infinite linear;
}
@keyframes l13{
  100%{transform: rotate(1turn)}
}

.popup-property {
  font-weight: 400;
  font-size: 12px;
  line-height: 15px;
  color: #9A9A9A;
}

.popup-value {
  font-weight: 400;
  font-size: 12px;
  line-height: 15px;
  color: #000000;
}

.popup-table tr td {
  padding: 5px;
}

.word-wrap {
  word-wrap: break-word; /* atau overflow-wrap: break-word; */
}

.container-legend{
  width: 100%;
  height: 100%;
  padding: 4px;
  border-radius: 5px;
  background-color: #FFFFFF;
}

.icon-legend {
  display: flex;
  align-items: center;
  flex-direction: row;
  gap: 1rem;
}

</style>
